import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LoginRegister.css";
import instance from "../../instance";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ChangePassword() {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [failedAttempts, setFailedAttempts] = useState(0);
  const navigate = useNavigate();

  const handleChangePassword = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    if (!token) {
      toast.error("You must be logged in to change your password.");
      return;
    }

    try {
      await instance.post(
        `users/change-password`,
        { oldPassword, newPassword },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("Password changed successfully");
      setFailedAttempts(0); // Reset failed attempts on success
      navigate("/");
    } catch (error) {
      console.error("Password change failed:", error);
      if (error.response && error.response.status === 400) {
        const newFailedAttempts = failedAttempts + 1;
        setFailedAttempts(newFailedAttempts);

        if (newFailedAttempts >= 3) {
          toast.error("Too many failed. Logging out.");
          localStorage.removeItem("token"); // Remove token to ensure the user is logged out
          navigate("/login"); // Redirect to login page
        } else {
          toast.error(`Old password is incorrect. ${newFailedAttempts}/3`);
        }
      } else {
        toast.error("Password change failed.");
      }
    }
  };

  return (
    <div>
      <header>
        <h2>Change Password</h2>
      </header>
      <button onClick={() => navigate("/")} className="button">
        ← Main
      </button>
      <div className="container">
        <div className="login-register-box">
          <main>
            <form onSubmit={handleChangePassword}>
              <div className="input-group">
                <label htmlFor="oldPassword">Old Password:</label>
                <input
                  type={showOldPassword ? "text" : "password"}
                  id="oldPassword"
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowOldPassword(!showOldPassword)}
                  className="show show-password-toggle"
                >
                  {showOldPassword ? "Hide" : "Show"}
                </button>
              </div>

              <div className="input-group">
                <label htmlFor="newPassword">New Password:</label>
                <input
                  type={showNewPassword ? "text" : "password"}
                  id="newPassword"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowNewPassword(!showNewPassword)}
                  className="show show-password-toggle"
                >
                  {showNewPassword ? "Hide" : "Show"}
                </button>
              </div>

              <button className="button4" type="submit">
                Change Password
              </button>
            </form>
          </main>
        </div>
      </div>
    </div>
  );
}

export default ChangePassword;
